import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetIdentity } from "@refinedev/core";

const NAV_ITEMS = [
  { key: "overview", label: "Overview", path: "/digibox" },
  { key: "policies", label: "Policies", path: "/digibox/policies" },
  { key: "content", label: "Contenuti", path: "/digibox/content" },
  { key: "archive", label: "Archivio", path: "/digibox/archive" },
  { key: "upload", label: "I Miei File", path: "/digibox/upload" },
  { key: "timeline", label: "Attività", path: "/digibox/timeline" },
];

/** Read portal session from localStorage (set at portal login) */
function getPortalSession(): { contactId: string; contactName: string } | null {
  try {
    const raw = localStorage.getItem("portal_session");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const VaultHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: identity } = useGetIdentity<{ name: string; id?: string }>();
  const portal = getPortalSession();

  const displayName = portal?.contactName || identity?.name || identity?.id || "—";

  const handleLogout = async () => {
    try {
      await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
    } catch {
      // ignore
    }
    localStorage.removeItem("portal_session");
    localStorage.removeItem("user");
    navigate("/digibox/login");
  };

  const activeKey = (() => {
    if (location.pathname.startsWith("/digibox/policies")) return "policies";
    if (location.pathname.startsWith("/digibox/content")) return "content";
    if (location.pathname.startsWith("/digibox/archive")) return "archive";
    if (location.pathname.startsWith("/digibox/upload")) return "upload";
    if (location.pathname.startsWith("/digibox/timeline")) return "timeline";
    if (location.pathname === "/digibox") return "overview";
    return "";
  })();

  return (
    <header className="vault-header">
      <div>
        <span
          className="vault-brand"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/digibox")}
        >
          <span>DSGN</span>
          <span>VAULT</span>
        </span>
      </div>
      <div>
        <nav className="vault-nav-links">
          {NAV_ITEMS.map((item) => (
            <span
              key={item.key}
              className={`vault-nav-link ${activeKey === item.key ? "active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </span>
          ))}
        </nav>
      </div>
      <div className="vault-user-meta" style={{ display: "flex", alignItems: "center", gap: "var(--vault-spacing-sm)" }}>
        <span>{displayName}</span>
        <span
          className="vault-nav-link"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          Esci
        </span>
      </div>
    </header>
  );
};
